import "@accessible360/accessible-slick";
export const Marquee = (() => {
  "use strict";

  function init() {
    var myMarquee = $(".marquee:not(.slick-initialized)");

    setTimeout(function () {
      myMarquee.each(function () {
        var $slides = $(this).find(".slick-slide");

        var numClones = 3;

        for (var i = 0; i < numClones; i++) {
          $slides.clone().appendTo($(this));
        }

        var $marquee = $(this).slick({
          speed: 5000,
          autoplay: true,
          autoplaySpeed: 0,
          centerMode: true,
          cssEase: "linear",
          centerPadding: "0px",
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          initialSlide: 2,
          arrows: false,
          buttons: false,
          accessibility: true
        });

        $(this).on("mouseenter", function () {
          $marquee.slick("slickPause");
        });

        $(this).on("mouseleave", function () {
          $marquee.slick("slickPlay");
        });
      });
    }, 1);

    var lastMarqueeBlock = $('#pxMainContent .pxblock--marquee:last');

    if (lastMarqueeBlock.length > 0 && lastMarqueeBlock.next().length === 0) {
      $('.site-footer').css('margin-top', '0');
      $(lastMarqueeBlock).css('border-bottom', 'none');
    }
  }

  return {
    init: init,
    name: "marquee",
  };
})();
